import React from 'react';
import '../styles/InfluenceursCibles.css';
import { FaUserGraduate, FaInstagram, FaPenNib, FaUsers } from 'react-icons/fa';

const InfluenceursCibles = () => {
  const profils = [
    {
      icon: <FaUserGraduate />,
      title: "Étudiants dynamiques",
      description: "Motivés, connectés, et prêts à partager leur expérience avec leur entourage."
    },
    {
      icon: <FaInstagram />,
      title: "Influenceurs réseaux",
      description: "Actifs sur TikTok, Instagram, Facebook ou YouTube avec une communauté engagée."
    },
    {
      icon: <FaPenNib />,
      title: "Créateurs de contenu",
      description: "Blogueurs, vidéastes ou passionnés du digital qui aiment partager des bons plans."
    },
  
  ];

  return (
    <section className="cibles-section" id="cibles">
      <h2 className="cibles-title">Qui peut devenir <span className="highlight">influenceur chez nous ?</span></h2>
      <p className="cibles-intro">
        Rejoignez notre programme d’influenceur et gagnez des primes en recommandant notre service.
      </p>

      <div className="cibles-grid">
        {profils.map((profil, index) => (
          <div className="cible-card" key={index}>
            <div className="cible-icon">{profil.icon}</div>
            <h3>{profil.title}</h3>
            <p>{profil.description}</p>
          </div>
        ))}
      </div>

      <p className="cibles-outro">
        Chaque profil est important. L’essentiel, c’est de partager avec passion et authenticité. 💡
      </p>
    </section>
  );
};

export default InfluenceursCibles;
